<async-file-upload
    [maxFileSize]="maxFileSize"
    [disabled]="disabled"
    [(ngModel)]="file"
    (ngModelChange)="handleFileSelectChange($event)"
    (onFileUpload)="handleFileUpload()"
    (onFileUploadCancel)="handleFileUploadCancel()"
    (fileNameChange)="handleFileNameChange($event)"
    [fileName]="fileName"
    [loadingState]="loadingState"
    [enableCancel]="enableCancel"
    [accept]="accept"
    [error]="errors"
></async-file-upload>
